export const SettingsRoutes = {
    Profile: 'profile',
    ProfileEdit: 'profile/edit',
    Settings: 'profile/settings',
    ChangePassword: 'profile/change-password',
    ChangeLogin: 'profile/change-login',
};
